import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { FirestoreBase } from '../../core/db/firestore-base';
import { Order } from './order.models';

/**
 * Order Firestore data-access service.
 * Extends {@link FirestoreBase} to reuse generic CRUD and query helpers.
 * Use inherited methods such as `get$`, `getOneWhere$`, `create`, `upsert`, and `update`
 * from higher layers (`order.service`) unless an order-specific query is required.
 */
@Injectable({ providedIn: 'root' })
export class OrderDbService extends FirestoreBase<Order> {
  constructor(firestore: Firestore) {
    super(
      'orders',
      firestore,
      { dateProperties: ['createdAt', 'updatedAt', 'cart.createdAt', 'cart.updatedAt'] }
    );
  }
}
